import React, { useState, useEffect, useRef } from "react";
import { createSearchParams, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';



const RecordAddStep2 = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [isBtn, setIsBtn] = useState(false);
    const [states, setStates] = useState(null);
    


    const recordFileRef = useRef();

    const uploadRecord = (event) => {
        setIsBtn(true);
        axios.post(process.env.REACT_APP_API_URL + "/get-data-from-document", {
            record: event.target.files[0],

        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    const entities = response?.data?.entities;
                    const fields = response?.data?.fields;
                    const text = response?.data?.text;
                    const file_name = response?.data?.file_name;

                    backToAddRecord(entities, fields, text,file_name);

                }
                else {
                    Swal.fire({ icon: "error", title: "Record cannot be retrieved", text: "We are unable to retrieve information from uploaded document, click 'Enter details manually' to add record manually." });

                }
                setIsBtn(false);

            })
            .catch(function (error) {
                setIsBtn(false);
                Swal.fire({ icon: "error", title: "Processing Error", text: "We are unable to retrieve information from uploaded document, click 'Enter details manually' to add record manually." });

            });


    }

    useEffect(() => {

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        getStates();


    }, []);


    

    const getStates = async (e) => {
        axios.get(process.env.REACT_APP_API_URL + "/get-states", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setStates(response?.data?.states);



                }
            })
            .catch(function (error) {

                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }




    const backToAddRecordBAK = async (entities, fields,text,file_name) => {

        console.log(entities, fields);
        console.log(text);

        const category = params.category;

        let license_no = "";
        let issue_date = "";
        let expiry_date = "";
        let issued_by = "";
        let other_info = "";
        let patient_info = "";
        let dob = "";
        let url = "";
        let notes = "";
        let address = "";


        Object.keys(fields).forEach(function (key) {

            const val = fields[key];
            key = key.toLocaleLowerCase();


            if (key.includes("license number") || key.includes("license no") || key.includes("license #") || key.includes("license#")) {
                license_no = val;
            }
            if (key.includes("license date") || key.includes("issue date") || key == "date" || key == "date of certification") {
                issue_date = val;
            }
            if (key.includes("expir") || key.includes("Renew")) {
                expiry_date = val;
            }
            if (key.includes("name") && patient_info == "") {
                patient_info += val + " ";
            }
            if (key.includes("patient") && patient_info == "") {
                patient_info += val;
            }
            if (key.includes("address") || key.includes("phone")) {
                address += val;
            }


            if (key.includes("dob") || key.includes("date of birth")) {
                dob = val;
            }
            if (key.includes("type")) {
                notes = val;
            }

        });
        let ivar = 0;
        Object.keys(entities).forEach(function (key) {

            const val = entities[key];
            key = key.toLocaleLowerCase();


            if (key.includes("organization") && ivar < 2) {
                issued_by += val + " ";
                ivar++;
            }
            else if (key.includes("organization") && ivar < 4) {
                other_info += val + " ";
            }

            if (key.includes("url")) {
                url = val;
            }
            if (key.includes("address")) {
                address = val;
            }
            if (issue_date == "" && key.includes("date_time") && val != expiry_date) {
                issue_date = val;
            }
            console.log(key, val, issued_by, "--")



        });



        let all_states = "";
        states.forEach(function (s) {
            all_states+=s.label+"|";
        });

        all_states = all_states.slice(0, -1); 
        console.log(all_states);

        let re = new RegExp(all_states, "i");
        console.log(re);


        let st = text.match(re);
        console.log(st);
        let state_id="";
        let state_name="";
        if(st && st?.length>0){
            st=st[0];

            st = states.find(s => s?.state_name?.toUpperCase() == st?.toUpperCase());
            console.log(st);

            if(st){
                state_id = st.state_id;
                state_name = st.state_name;
            }

        }


        if (category == "license") {

            navigate({
                pathname: "/records/record-add-license",
                search: createSearchParams({
                    license_no: license_no,
                    issue_date: issue_date,
                    expiry_date: expiry_date,
                    issued_by: issued_by,
                    other_info: other_info,
                    state_id:state_id,
                    state_name:state_name,
                    file_name:file_name,
                }).toString()
            });


        }
        else if (category == "certification") {

            navigate({
                pathname: "/records/record-add-certification",
                search: createSearchParams({
                    id: license_no,
                    issue_date: issue_date,
                    expiry_date: expiry_date,
                    issued_by: issued_by,
                    url: url,
                    address: address,
                    other_info: other_info,
                    notes: notes,
                    file_name:file_name,
                }).toString()
            });

        }
        else if (category == "vaccine") {
            navigate({
                pathname: "/records/record-add-vaccine",
                search: createSearchParams({
                    issue_date: issue_date,
                    expiry_date: expiry_date,
                    issued_by: issued_by,
                    other_info: other_info,
                    dob: dob,
                    patient_info: patient_info,
                    notes: notes,
                    address: address,
                    file_name:file_name,
                }).toString()
            });
        }

    };


    const backToAddRecord = async (entities, fields, text, file_name) => {

      
  const category = params.category;

  /* ===============================
     NORMALIZATION HELPERS
  =============================== */

  const normalizeKey = (k = "") =>
    k.toLowerCase().replace(/[^a-z0-9]/g, " ").trim();

  const pickIfEmpty = (current, value) =>
    current ? current : value;

  const textIncludes = (key, patterns) =>
    patterns.some(p => key.includes(p));

  /* ===============================
     INITIAL VALUES
  =============================== */

  let data = {
    license_no: "",
    issue_date: "",
    expiry_date: "",
    issued_by: "",
    other_info: "",
    patient_info: "",
    dob: "",
    url: "",
    notes: "",
    address: "",
  };

  /* ===============================
     EXTRACT FROM FORM FIELDS
  =============================== */

  Object.entries(fields || {}).forEach(([rawKey, rawVal]) => {
    const key = normalizeKey(rawKey);
    const val = typeof rawVal === "object" ? rawVal.value : rawVal;

    if (!val) return;

    // License / ID
    if (textIncludes(key, [
      "license number",
      "license no",
      "license id",
      "id number",
      "document id",
      "certificate id"
    ])) {
      data.license_no = pickIfEmpty(data.license_no, val);
    }

    // Dates
    if (textIncludes(key, ["issue date","issued","date of issue","certification date","effective date","effective","start date","begin date","valid from","commencement date","approval date","granted on"]) && !textIncludes(key, ["expire","expiry","expiration","renew","valid thru","valid through","end date"])) {
      data.issue_date = pickIfEmpty(data.issue_date, val);
    }

    if (textIncludes(key, ["expires","expiry","expiration","expiring","valid thru","valid through","expires on","end date","renew","renewal","valid until","termination date","end of validity"])) {
      data.expiry_date = pickIfEmpty(data.expiry_date, val);
    }

    // Patient / Name
    if (textIncludes(key, ["patient", "name", "holder"])) {
      data.patient_info = pickIfEmpty(data.patient_info, val);
    }

    // DOB
    if (textIncludes(key, ["dob", "date of birth"])) {
      data.dob = pickIfEmpty(data.dob, val);
    }

    // Address / Phone
    if (textIncludes(key, ["address", "phone", "location"])) {
      data.address += val + " ";
    }

    // Notes / Type
    if (textIncludes(key, ["type", "category"])) {
      data.notes = pickIfEmpty(data.notes, val);
    }
  });

  /* ===============================
     EXTRACT FROM ENTITIES
  =============================== */

  let orgCount = 0;

  Object.entries(entities || {}).forEach(([rawKey, entity]) => {
    const key = normalizeKey(rawKey);
    const val = entity?.value || entity;

    if (!val) return;
    // License / ID (Entity-level)

    if (textIncludes(key, ["license", "id", "document"])) {
      data.license_no = pickIfEmpty(data.license_no, val);
    }

    // Organization
    if (key.includes("organization")) {
      if (orgCount < 2) {
        data.issued_by += val + " ";
      } else {
        data.other_info += val + " ";
      }
      orgCount++;
    }

    // URL
    if (key.includes("url")) {
      data.url = pickIfEmpty(data.url, val);
    }

    // Address
    if (key.includes("address")) {
      data.address = pickIfEmpty(data.address, val);
    }

    // Date fallback
    if (!data.issue_date && key.includes("date")) {
      if (val !== data.expiry_date) {
        data.issue_date = val;
      }
    }
  });

  /* ===============================
     STATE DETECTION (OCR TEXT)
  =============================== */

  let state_id = "";
  let state_name = "";

  const stateRegex = new RegExp(
    states.map(s => s.state_name).join("|"),
    "i"
  );

  const stateMatch = text.match(stateRegex);

  if (stateMatch) {
    const found = states.find(
      s => s.state_name.toLowerCase() === stateMatch[0].toLowerCase()
    );

    if (found) {
      state_id = found.state_id;
      state_name = found.state_name;
    }
  }

  /* ===============================
     NAVIGATION
  =============================== */

  const commonParams = {
    issue_date: data.issue_date,
    expiry_date: data.expiry_date,
    issued_by: data.issued_by.trim(),
    other_info: data.other_info.trim(),
    file_name
  };

  if (category === "license") {
    navigate({
      pathname: "/records/record-add-license",
      search: createSearchParams({
        license_no: data.license_no,
        state_id,
        state_name,
        ...commonParams
      }).toString()
    });
  }

  else if (category === "certification") {
    navigate({
      pathname: "/records/record-add-certification",
      search: createSearchParams({
        id: data.license_no,
        url: data.url,
        address: data.address.trim(),
        notes: data.notes,
        ...commonParams
      }).toString()
    });
  }

  else if (category === "vaccine") {
    navigate({
      pathname: "/records/record-add-vaccine",
      search: createSearchParams({
        dob: data.dob,
        patient_info: data.patient_info,
        address: data.address.trim(),
        notes: data.notes,
        ...commonParams
      }).toString()
    });
  }
};


    const backToRecords = async (e) => {
        navigate("/records")
    };


    const backToAddManually = async (e) => {

        const category = params.category;
        if (category == "license") {

            navigate("/records/record-add-license");


        }
        else if (category == "certification") {
            navigate("/records/record-add-certification");

        }
        else if (category == "vaccine") {
            navigate("/records/record-add-vaccine");

        }


    };

    return (
        <>
          
          <div className="title-box">
                <div className="flex-equal justify-content-start " >
                    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToRecords} >

                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
                        </svg>
                        <label >Back</label>

                    </button>

                </div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Add to Records</h3>
                <div className="flex-equal justify-content-end" >

                </div>

            </div>

            <div className="box" >

                <div className="form-content form-content-lg p-32" >

                    

                            <div className="" >

                                <button className="btn btn-secondary d-flex fd-row align-items-center" onClick={() => recordFileRef.current.click()}>

                                    {isBtn ? <><div className="spinner"></div> <label> Scanning records, finding missing pieces.</label></> :
                                        <> <span>Upload Record</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                            <path d="M9.45811 7.51429L6.23632 10.7361L4.76318 9.26294L10.4998 3.52637L16.2363 9.26294L14.7632 10.7361L11.5414 7.51434L11.5414 14.9996H9.45811L9.45811 7.51429Z" fill="white" />
                                        </svg>
                                        </>
                                    }
                                </button>
                                <input onInput={uploadRecord} multiple={false} ref={recordFileRef} type='file' hidden />

                            </div>


                            <div className="p-32" onClick={backToAddManually} >

                                <div className="box-title color-white fs-18 fs-helvetica cursor-pointer" >

                                    Enter Details Manually

                                </div>

                            </div>

                      

                </div>
            </div>


        </>


    );
};

export default RecordAddStep2;